<div class="mat-modal-dialog unreachable-vehicle-modal">
    <mat-icon class="close-icon" (click)="onClose()">close</mat-icon>
    <h2 mat-dialog-title class="alert-dialog-title">
        <span class="material-icons-outlined alert-info-icon">info</span>
        <span class="alert-title-text">Unreachable Vehicle Alert</span>
    </h2>
    <div class="row mat-dialog-content d-flex">
        <div class="col-sm-12 col-md-12">
            <div class="table-responsive" *ngIf="alerts.length > 0">
                <table class="unreachable-vehicle-table">
                    <thead>
                        <tr>
                            <th>Trip Code</th>
                            <th>Vehicle Number</th>
                            <th>Driver Name</th>
                            <th>Driver Contact Number</th>
                            <th>Lat/Long</th>
                            <th>Location Updated On</th>
                            <th>Call</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let alert of alerts">
                            <td>
                                <button class="btn unreachable-map-view" (click)="openMapView(alert)"
                                    [disabled]="!hasMapLocation(alert)">
                                    <span class="trip-code-btn-text">{{ displayValue(alert.tripCode) }}</span>
                                </button>
                            </td>
                            <td>{{ displayValue(alert.vehicleRegistrationNumber) }}</td>
                            <td>{{ displayValue(alert.driverName) }}</td>
                            <td>{{ displayValue(alert.driverContactNumber) }}</td>
                            <td>{{ displayLatLong(alert) }}</td>
                            <td>{{ displayValue(alert.locationUpdatedOn) }}</td>
                            <td>
                                <button class="btn unreachable-call" (click)="doIVRCall(alert.tripId)">
                                    <span class="call-btn-text">Call</span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>